module.exports = __webpack_public_path__ + "img/icon_证书_D级赛事@2x.1bcdcb2d.png";